import { Container, Stack, Table, Form, Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { firestore } from "..";
import RepeatIcon, {
  CheckCircleIcon,
  CircleIcon,
  HeartIcon,
  Heart_fillIcon,
} from "../images/SVGs";
import { BasicColor } from "../Utils/constants";
import { BounceLoader } from "react-spinners";
import { currTranslation } from "../Utils/constants";
import { toEnglishNumber } from "../Utils/Miscellaneous";

function Calculator() {
  const [btnClicked, setBtnClicked] = useState(false);
  const [scrapedData, setScrapedData] = useState([]);
  const [favourites, setFavourites] = useState([]);
  const [displayedData, setDisplayedData] = useState([]);
  const [displayFavourites, setDisplayFavourites] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const [amount, setAmount] = useState(1);
  const [language, setLanguage] = useState("ar");
  const [egpBankPeice, setEgpBankPeice] = useState(false);
  const [egpBankPeiceValue, setEgpBankPeiceValue] = useState(false);
  const [egpMarketPriceValue, setEgpMarketPriceValue] = useState(0);

  useEffect(() => {
    handleClick();
    let tempFavoouritesStr = localStorage.getItem("calculatorFavourites");
    if (tempFavoouritesStr) {
      setFavourites(JSON.parse(tempFavoouritesStr));
    }
    getEgpMarketPrice();
  }, []);

  const getEgpMarketPrice = async () => {
    try {
      // Directly query the Firestore document with ID 'aly'
      const docRef = firestore.collection("scrapedData").doc("aly");
      const docSnapshot = await docRef.get();

      if (docSnapshot.exists) {
        const resultArr = docSnapshot.data().data;

        console.log("Retrieved specific data:", resultArr);
        const buyPrice = parseFloat(resultArr[0]);
        const ouncePriceBuy = parseFloat(resultArr[2].replace(",", ""));

        setEgpMarketPriceValue(buyPrice / (ouncePriceBuy / 31.1));
      } else {
        console.log('Document with ID "aly" not found');
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      // toggleEgpBankPrice();
    }
  };

  const toggleFavourite = (currencyAbbreviation) => {
    let tempFavourites = [...favourites];

    if (favourites.includes(currencyAbbreviation)) {
      tempFavourites = favourites.filter(
        (item) => item !== currencyAbbreviation
      );
    } else {
      tempFavourites.push(currencyAbbreviation);
    }
    localStorage.setItem(
      "calculatorFavourites",
      JSON.stringify(tempFavourites)
    );
    setFavourites(tempFavourites);
  };

  const toggleDisplayedData = () => {
    let tempDataArr = scrapedData;
    if (displayFavourites) {
      tempDataArr = Object.entries(scrapedData)
        .filter(([currency]) => favourites.includes(currency))
        .reduce((acc, [currency, rate]) => {
          acc[currency] = rate;
          return acc;
        }, {});
    }
    calculateCurrencies(tempDataArr);
    setDisplayFavourites(!displayFavourites);
    setSearchValue("");
  };

  const handleClick = async () => {
    setBtnClicked(true);
    try {
      // Directly query the Firestore document with ID 'aly'
      // conversion_rates
      const docRef = firestore.collection("exchangeApi").doc("aly");
      const docSnapshot = await docRef.get();

      if (docSnapshot.exists) {
        const resultArr = docSnapshot.data();

        console.log("Retrieved specific data:", resultArr);

        // Update state with the fetched data
        const sortedExchangeRates = Object.fromEntries(
          Object.entries(resultArr["conversion_rates"]).sort()
        );
        setScrapedData(sortedExchangeRates);
        setDisplayedData(sortedExchangeRates);
        setAmount(1);
        setSearchValue("");
        setEgpBankPeiceValue(sortedExchangeRates["EGP"]);
      } else {
        console.log('Document with ID "aly" not found');
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setBtnClicked(false);
    }
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    let tempDataArr = displayedData;
    const searchTerm = e.target.value.toLowerCase(); // Convert search value to lowercase
    tempDataArr = Object.entries(displayedData)
      .filter(([currency]) => {
        return currency.toLowerCase().includes(searchTerm); // Convert currency to lowercase for case-insensitive comparison
      })
      .reduce((acc, [currency, rate]) => {
        acc[currency] = rate;
        return acc;
      }, {});
    calculateCurrencies(tempDataArr);
    if (!searchTerm) {
      setDisplayFavourites(!displayFavourites);
      toggleDisplayedData();
    }
  };

  useEffect(() => {
    calculateCurrencies(displayedData);
  }, [amount, selectedCurrency]);

  function calculateCurrencies(myArray) {
    let tempArr = {};
    const factor = scrapedData[selectedCurrency];
    Object.keys(myArray).map((key) => {
      let value = (scrapedData[key] / factor) * parseFloat(amount);
      tempArr[key] = parseFloat(value.toFixed(2));
    });
    setDisplayedData(tempArr);
  }

  const handleAmountChange = (e) => {
    let tempAmount = toEnglishNumber(e.target.value);
    setAmount(tempAmount);
  };

  const handleChangeSelectedCurrency = (item) => {
    setSelectedCurrency(item);
  };

  const translate = () => {
    if (language === "abbr") {
      setLanguage("ar");
    } else {
      setLanguage("abbr");
    }
  };

  useEffect(() => {
    toggleEgpBankPrice();
  }, [egpBankPeice]);

  const toggleEgpBankPrice = () => {
    if (egpBankPeice) {
      let TempScrapedData = scrapedData;
      TempScrapedData["EGP"] = egpMarketPriceValue;
      setScrapedData(TempScrapedData);
    } else {
      let TempScrapedData = scrapedData;
      TempScrapedData["EGP"] = egpBankPeiceValue;
      setScrapedData(TempScrapedData);
    }
    calculateCurrencies(displayedData);
  };

  return (
    <Container>
      <div dir={language === "ar" ? "rtl" : "ltr"}>
        <Stack direction="horizontal" gap={1}>
          <h1>الحاسبة</h1>
          <dir
            onClick={() => {
              handleClick();
            }}
          >
            {RepeatIcon(BasicColor, 30)}
          </dir>
        </Stack>

        {btnClicked && (
          <BounceLoader
            color={BasicColor}
            loading={btnClicked}
            size={50}
            aria-label="Loading Spinner"
            data-testid="BounceLoader"
          />
        )}
        {/* <Button onClick={translate}>Translate</Button> */}
        <Form.Group>
          <Stack direction="horizontal" gap={1}>
            <div>
              <Form.Label>بحث بأحرف الاختصار الانجليزية </Form.Label>
            </div>
            <Form.Control
              type="text"
              autoComplete="on"
              value={searchValue}
              onChange={handleSearch}
            />
          </Stack>
        </Form.Group>
        <br />

        <Form.Group>
          <Stack direction="horizontal" gap={1}>
            <Form.Label>{selectedCurrency}</Form.Label>
            <Form.Control
              type="text"
              value={toEnglishNumber(amount)}
              onChange={handleAmountChange}
            />
          </Stack>
        </Form.Group>

        <table style={{ margin: "5px" }}>
          <tbody>
            <tr>
              <td>سعر الجنيه المصري بحسب: </td>
              <td></td>
              <td>السوق</td>
              <td
                onClick={() => {
                  setEgpBankPeice(!egpBankPeice);
                }}
              >
                {egpBankPeice
                  ? CheckCircleIcon(BasicColor, 20)
                  : CircleIcon(BasicColor, 20)}
              </td>
              <td></td>

              <td>البنك</td>
              <td
                onClick={() => {
                  setEgpBankPeice(!egpBankPeice);
                }}
              >
                {!egpBankPeice
                  ? CheckCircleIcon(BasicColor, 20)
                  : CircleIcon(BasicColor, 20)}
              </td>
            </tr>
          </tbody>
        </table>
        <Table>
          <thead>
            <tr>
              <td></td>
              <th>الاختصار</th>
              <th>الاسم</th>
              <th>السعر</th>
              <th onClick={toggleDisplayedData}>
                {displayFavourites
                  ? Heart_fillIcon(BasicColor, 16)
                  : HeartIcon(BasicColor, 16)}
              </th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(displayedData).map((item, index) => (
              <tr key={index}>
                <td onClick={() => handleChangeSelectedCurrency(item)}>
                  {item === selectedCurrency
                    ? CheckCircleIcon(BasicColor, 20)
                    : CircleIcon(BasicColor, 20)}
                </td>
                <td
                  style={{
                    backgroundColor: item === selectedCurrency && "lightgrey",
                  }}
                >
                  {item}
                </td>
                <td
                  style={{
                    backgroundColor: item === selectedCurrency && "lightgrey",
                  }}
                >
                  {language === "abbr" ? item : currTranslation[item]}
                </td>
                <td
                  style={{
                    backgroundColor: item === selectedCurrency && "lightgrey",
                  }}
                >
                  {displayedData[item]}
                </td>
                <td onClick={() => toggleFavourite(item)}>
                  {favourites.includes(item)
                    ? Heart_fillIcon(BasicColor, 16)
                    : HeartIcon(BasicColor, 16)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Container>
  );
}

export default Calculator;
